// extracted by mini-css-extract-plugin
export var fadeInOut = "_t-3";
export var icon = "_t-4";
export var savedIndicator = "_t-2";
export var savingIndicator = "_t-0";
export var spin = "_t-1";